export const ourProducts = [
    {
      title: 'Smart City Management Platforms', 
      subtitle:
        'Transform your city into a smart and efficient urban hub with our comprehensive Smart City Management Platforms. From intelligent transportation to energy management, these platforms provide a unified solution for urban development.',
      img: 'url(/industries/infrastructure/smart-city-management-platforms.avif)',
      content:
        'From intelligent transportation to energy management, our Smart City Management Platforms transform your city into a smart and efficient urban hub.',
      link: '/industries/infrastructure/products/smart-city-management-platforms',
    },
    {
      title: 'Building Information Modeling (BIM) and Construction Management Software',
      subtitle:
        'Revolutionize construction processes with our BIM and Construction Management Software. Visualize, plan, and manage construction projects efficiently, ensuring precision and collaboration throughout the building lifecycle.',
      img: 'url(/industries/infrastructure/bim-and-construction-management-software.avif)',
      content:
        'Visualize, plan, and manage construction projects efficiently, ensuring precision and collaboration throughout the building lifecycle with our BIM and Construction Management Software.',
      link: '/industries/infrastructure/products/bim-and-construction-management-software',
    },
    {
      title: 'Infrastructure Asset Management Systems',
      subtitle:
        'Optimize the lifespan of your infrastructure assets with our Asset Management Systems. From bridges to utilities, efficiently manage maintenance, monitor performance, and extend the longevity of critical assets.',
      img: 'url(/industries/infrastructure/infrastructure-asset-management-systems.avif)',
      content:
        'Efficiently manage maintenance, monitor performance, and extend the longevity of critical assets with our Infrastructure Asset Management Systems.',
      link: '/industries/infrastructure/products/infrastructure-asset-management-systems',
    },
    {
      title: 'Digital Twin Technology for Urban Planning',
      subtitle:
        'Envision the future of urban planning with Digital Twin Technology. Create virtual replicas of cities, simulate scenarios, and make data-driven decisions for sustainable and resilient urban development.',
      img: 'url(/industries/infrastructure/digital-twin-technology-for-urban-planning.avif)',
      content:
        'Create virtual replicas of cities, simulate scenarios, and make data-driven decisions for sustainable and resilient urban development with Digital Twin Technology.',
      link: '/industries/infrastructure/products/digital-twin-technology-for-urban-planning',
    },
    {
      title: 'Smart Building Energy Management Systems',
      subtitle:
        'Maximize energy efficiency in buildings with our Smart Building Energy Management Systems. Monitor and control energy consumption, reduce costs, and contribute to sustainable building practices.',
      img: 'url(/industries/infrastructure/smart-building-energy-management-systems.avif)',
      content:
        'Monitor and control energy consumption, reduce costs, and contribute to sustainable building practices with our Smart Building Energy Management Systems.',
      link: '/industries/infrastructure/products/smart-building-energy-management-systems',
    },
    {
      title: 'Traffic Management and Urban Mobility Solutions',
      subtitle:
        'Streamline traffic flow and enhance urban mobility with our Traffic Management Solutions. From intelligent signal control to real-time traffic monitoring, optimize transportation for a connected and efficient city.',
      img: 'url(/industries/infrastructure/traffic-management-and-urban-mobility-solutions.avif)',
      content:
        'From intelligent signal control to real-time traffic monitoring, optimize transportation for a connected and efficient city with our Traffic Management Solutions.',
      link: '/industries/infrastructure/products/traffic-management-and-urban-mobility-solutions',
    },
    {
      title: 'Utility Infrastructure Monitoring and Optimization Software',
      subtitle:
        'Ensure the reliability of utility services with our Infrastructure Monitoring Software. Monitor and optimize utility infrastructure, preventing disruptions and ensuring a seamless experience for residents and businesses.',
      img: 'url(/industries/infrastructure/utility-infrastructure-monitoring-and-optimization-software.jpg)',
      content:
        'Monitor and optimize utility infrastructure, preventing disruptions and ensuring a seamless experience for residents and businesses with our Infrastructure Monitoring Software.',
      link: '/industries/infrastructure/products/utility-infrastructure-monitoring-and-optimization-software',
    },
    {
      title: 'Geospatial Information Systems (GIS) for Infrastructure',
      subtitle:
        'Leverage the power of GIS for Infrastructure. Map, analyze, and visualize spatial data for informed decision-making in urban planning, infrastructure development, and resource optimization.',
      img: 'url(/industries/infrastructure/gis-for-infrastructure.jpg)',
      content:
        'Map, analyze, and visualize spatial data for informed decision-making in urban planning, infrastructure development, and resource optimization with GIS for Infrastructure.',
      link: '/industries/infrastructure/products/gis-for-infrastructure',
    },
    {
      title: 'Public Safety and Emergency Management Software',
      subtitle:
        'Enhance public safety with our Emergency Management Software. From disaster response planning to real-time incident tracking, ensure a swift and coordinated response to emergencies.',
      img: 'url(/industries/infrastructure/public-safety-and-emergency-management-software.avif)',
      content:
        'From disaster response planning to real-time incident tracking, ensure a swift and coordinated response to emergencies with our Public Safety and Emergency Management Software.',
      link: '/industries/infrastructure/products/public-safety-and-emergency-management-software',
    },
    {
      title: 'Urban Resilience and Disaster Recovery Planning Tools',
      subtitle:
        'Build resilient cities with our Disaster Recovery Planning Tools. Plan for and mitigate the impact of disasters, ensuring quick recovery and continuity in the face of unforeseen challenges.',
      img: 'url(/industries/infrastructure/urban-resilience-and-disaster-recovery-planning-tools.jpg)',
      content:
        'Plan for and mitigate the impact of disasters, ensuring quick recovery and continuity in the face of unforeseen challenges with our Urban Resilience and Disaster Recovery Planning Tools.',
      link: '/industries/infrastructure/products/urban-resilience-and-disaster-recovery-planning-tools',
    },
    {
      title: 'Sustainable Infrastructure Design and Planning Software',
      subtitle:
        'Foster sustainable urban development with our Infrastructure Design and Planning Software. Integrate environmental considerations into infrastructure projects, promoting eco-friendly and resilient solutions.',
      img: 'url(/industries/infrastructure/sustainable-infrastructure-design-and-planning-software.avif)',
      content:
        'Integrate environmental considerations into infrastructure projects, promoting eco-friendly and resilient solutions with our Sustainable Infrastructure Design and Planning Software.',
      link: '/industries/infrastructure/products/sustainable-infrastructure-design-and-planning-software',
    },
    {
      title: 'Integrated Public Transportation Management Systems',
      subtitle:
        'Create efficient and interconnected public transportation networks with our Integrated Management Systems. From route optimization to fare collection, enhance the overall public transportation experience.',
      img: 'url(/industries/infrastructure/integrated-public-transportation-management-systems.jpg)',
      content:
        'From route optimization to fare collection, enhance the overall public transportation experience with our Integrated Public Transportation Management Systems.',
      link: '/industries/infrastructure/products/integrated-public-transportation-management-systems',
    },
    {
      title: 'Municipal Budgeting and Financial Management Software',
      subtitle:
        'Streamline financial processes with our Municipal Budgeting Software. Manage budgets, allocate resources effectively, and ensure fiscal responsibility for sustainable municipal growth.',
      img: 'url(/industries/infrastructure/municipal-budgeting-and-financial-management-software.avif)',
      content:
        'Manage budgets, allocate resources effectively, and ensure fiscal responsibility for sustainable municipal growth with our Municipal Budgeting and Financial Management Software.',
      link: '/industries/infrastructure/products/municipal-budgeting-and-financial-management-software',
    },
    {
      title: 'GIS-Based Land Use Planning and Zoning Tools',
      subtitle:
        'Optimize land use planning and zoning decisions with our GIS-based tools. Analyze spatial data, identify suitable zones, and support informed decisions for balanced urban development.',
      img: 'url(/industries/infrastructure/gis-based-land-use-planning-and-zoning-tools.avif)',
      content:
        'Analyze spatial data, identify suitable zones, and support informed decisions for balanced urban development with our GIS-Based Land Use Planning and Zoning Tools.',
      link: '/industries/infrastructure/products/gis-based-land-use-planning-and-zoning-tools',
    },
    {
      title: 'Water and Wastewater Management Software',
      subtitle:
        'Ensure the efficient management of water resources with our Water and Wastewater Management Software. Monitor water quality, optimize distribution, and manage wastewater treatment processes.',
      img: 'url(/industries/infrastructure/water-and-wastewater-management-software.jpg)',
      content:
        'Monitor water quality, optimize distribution, and manage wastewater treatment processes with our Water and Wastewater Management Software.',
      link: '/industries/infrastructure/products/water-and-wastewater-management-software',
    },
    {
      title: 'Smart Lighting and Energy-Efficient Street Infrastructure',
      subtitle:
        'Illuminate urban spaces intelligently with our Smart Lighting solutions. Save energy, enhance safety, and create vibrant urban environments with energy-efficient street infrastructure.',
      img: 'url(/industries/infrastructure/smart-lighting-and-energy-efficient-street-infrastructure.avif)',
      content:
        'Save energy, enhance safety, and create vibrant urban environments with our Smart Lighting solutions and energy-efficient street infrastructure.',
      link: '/industries/infrastructure/products/smart-lighting-and-energy-efficient-street-infrastructure',
    },
    {
      title: 'Asset Performance Monitoring and Maintenance Systems',
      subtitle:
        'Optimize asset performance and maintenance with our monitoring systems. Ensure the reliability of critical infrastructure assets through proactive monitoring and predictive maintenance.',
      img: 'url(/industries/infrastructure/asset-performance-monitoring-and-maintenance-systems.avif)',
      content:
        'Ensure the reliability of critical infrastructure assets through proactive monitoring and predictive maintenance with our Asset Performance Monitoring and Maintenance Systems.',
      link: '/industries/infrastructure/products/asset-performance-monitoring-and-maintenance-systems',
    },
    {
      title: 'Cloud-Based Collaboration Platforms for Infrastructure Projects',
      subtitle:
        'Foster collaboration in infrastructure projects with our Cloud-Based Platforms. Enable real-time communication, document sharing, and collaborative project management for successful infrastructure development.',
      img: 'url(/industries/infrastructure/cloud-based-collaboration-platforms-for-infrastructure-projects.avif)',
      content:
        'Enable real-time communication, document sharing, and collaborative project management for successful infrastructure development with our Cloud-Based Collaboration Platforms for Infrastructure Projects.',
      link: '/industries/infrastructure/products/cloud-based-collaboration-platforms-for-infrastructure-projects',
    },
    {
      title: 'Noise and Air Quality Monitoring Solutions',
      subtitle:
        'Prioritize the well-being of urban residents with our Monitoring Solutions. Monitor noise and air quality, identify potential issues, and implement measures to create a healthier living environment.',
      img: 'url(/industries/infrastructure/noise-and-air-quality-monitoring-solutions.avif)',
      content:
        'Monitor noise and air quality, identify potential issues, and implement measures to create a healthier living environment with our Noise and Air Quality Monitoring Solutions.',
      link: '/industries/infrastructure/products/noise-and-air-quality-monitoring-solutions',
    },
    {
      title: 'Digital Permitting and Regulatory Compliance Software',
      subtitle:
        'Simplify the permitting process and ensure regulatory compliance with our Digital Permitting Software. Streamline approvals, reduce paperwork, and promote efficient and transparent regulatory processes.',
      img: 'url(/industries/infrastructure/digital-permitting-and-regulatory-compliance-software.avif)',
      content:
        'Streamline approvals, reduce paperwork, and promote efficient and transparent regulatory processes with our Digital Permitting and Regulatory Compliance Software.',
      link: '/industries/infrastructure/products/digital-permitting-and-regulatory-compliance-software',
    },
  ]

